import React from 'react';
import Banner from 'legacyfrontend/components/home/bannerComponents/Banner';
import { isV1Banner } from '../model/bannerModel';
import EmpresaBannerCard from './EmpresaBannerCard';

export default function EmpresaBannerSlot({ data, className, hoverOverlay, templateOverride }) {
  if (isV1Banner(data)) {
    return (
      <EmpresaBannerCard
        className={className}
        data={data}
        hoverOverlay={hoverOverlay}
        templateOverride={templateOverride}
      />
    );
  }

  return <Banner className={className} data={data} />;
}
